import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

import { API_URLS } from "../../config/app.constants";
import { HttpinterceptorService } from "./httpinterceptor.service";

const CACHE_SIZE = 1;

@Injectable({
  providedIn: "root",
})
export class GlobalService {
  private cache$: Observable<any>;
  petList: any[];

  // private activatedBoardService = new BehaviorSubject<string>("");
  // public currentBoardService = this.activatedBoardService.asObservable();

  constructor(private http: HttpinterceptorService) {}

  get settingsCacheData() {
    if (!this.cache$) {
      this.cache$ = this.getPetTypes().pipe(shareReplay(CACHE_SIZE));
    }
    return this.cache$;
  }

  // getCurrentBoardServiceData(data) {
  //   this.activatedBoardService.next(data);
  // }
  public getPetTypes() {
    return this.http.post(API_URLS.PET_TYPES, {}, false).pipe(
      map((response: any) => {
        let petList = [];
        if (response.type === "success") {
          if (response.data) {
            for (let index in response.data) {
              petList.push({ id: index, name: response.data[index] });
            }
            return petList;
          }
        }
      })
    );
  }
}
